import { render, staticRenderFns } from "./SenmonCareDiv.vue?vue&type=template&id=5475e730&"
import script from "./SenmonCareDiv.vue?vue&type=script&lang=ts&"
export * from "./SenmonCareDiv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports